import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseActivityEntity } from './activity-history/base-activity.entity';
import { JobEntity } from './job.entity';

/** PD-17797 — a job's change feed, as `opportunity_activity` is for opportunities. */
@Index('idx_ja_job_created', ['fkJobId', 'createdDate'], {})
@Index('idx_ja_type', ['activityType'], {})
@Index('idx_ja_user', ['fkUserId'], {})
@Entity('job_activity')
export class JobActivityEntity extends BaseActivityEntity {
	@Column('int', { name: 'fk_job__id', unsigned: true })
	public fkJobId!: number;

	@ManyToOne(() => JobEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_job__id', referencedColumnName: 'id' }])
	public job!: JobEntity;
}
